import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { AnimatePresence, motion } from 'framer-motion';
import { PlusIcon } from 'lucide-react';
import { ritualSteps } from '../../data/ritual';
import type { Product } from '../../types/product';
export function ProductDetails({
  product
}: {
  product: Product;
}) {
  const [open, setOpen] = useState<number>(0);
  const sections = [{
    title: 'Wat het is',
    body: product.what
  }, {
    title: 'Wat het doet',
    body: product.does
  }, {
    title: 'Hoe je het gebruikt',
    body: product.use
  }];
  const step = product.ritualStep ? ritualSteps[product.ritualStep - 1] : undefined;
  return <section id="details" className="mx-auto grid max-w-7xl gap-10 px-5 py-16 lg:grid-cols-12 lg:px-8 lg:py-24" data-id="element-304" data-mp="np6wswbvdyn1">
      <div className="lg:col-span-7" data-id="element-305" data-mp="skchxsxg79a2">
        <h2 className="text-3xl font-semibold tracking-display sm:text-4xl" data-id="element-306" data-mp="doo6bipsvjw5">Zonder omhaal</h2>
        <ul className="mt-8 border-b border-line" data-id="element-307" data-mp="iosmt8qpkemd">
          {sections.map((s, i) => {
          const isOpen = open === i;
          return <li key={s.title} className="border-t border-line" data-id="element-308" data-mp="32w2hoik5g1oc" data-mpi={i}>
                <button type="button" onClick={() => setOpen(isOpen ? -1 : i)} aria-expanded={isOpen} className="flex w-full items-center justify-between py-5 text-left text-lg font-semibold" data-id="element-309" data-mp="2xxr725m15n52">
                  {s.title}
                  <PlusIcon className={`h-5 w-5 transition-transform duration-200 ${isOpen ? 'rotate-45' : ''}`} aria-hidden="true" data-id="element-310" data-mp="2k87aximyfo4q" />
                </button>
                <AnimatePresence initial={false} data-id="element-311" data-mp="2szhbhtwe8kix">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.22,
                ease: [0.23, 1, 0.32, 1]
              }} className="overflow-hidden" data-id="element-312" data-mp="2t1k7cuk897vk">
                      <p className="max-w-2xl pb-6 text-lg leading-relaxed text-muted" data-id="element-313" data-mp="3vm1wt3v1nc0a">{s.body}</p>
                    </motion.div>}
                </AnimatePresence>
              </li>;
        })}
        </ul>
      </div>

      {step && product.ritualStep && <aside className="self-start rounded-3xl bg-surface p-8 lg:col-span-4 lg:col-start-9" data-id="element-314" data-mp="e4s4qdy5vsdf">
          <p className="text-sm font-medium text-clay" data-id="element-315" data-mp="3cos93aiorcd8">Stap {product.ritualStep} van 9</p>
          <p className="mt-2 text-2xl font-semibold tracking-tight" data-id="element-316" data-mp="3hm0nd00pqw97">{step.title}</p>
          <p className="mt-2 text-muted" data-id="element-317" data-mp="3mldgg2i6gzk8">{step.text}</p>
          <div className="mt-6 flex gap-1" aria-hidden="true" data-id="element-318" data-mp="3mnzp65gt1l41">
            {ritualSteps.map((_, i) => <span key={i} className={`h-1 flex-1 rounded-full ${i < product.ritualStep! ? 'bg-clay' : 'bg-line'}`} data-id="element-319" data-mp="3riwxtba69sge" data-mpi={i} />)}
          </div>
          <Link to="/over-amira#ritueel" className="mt-6 inline-block text-sm font-medium underline underline-offset-4" data-id="element-320" data-mp="16tzb1z3uxm98">
            Bekijk het hele ritueel
          </Link>
        </aside>}
    </section>;
}